module.exports = __webpack_public_path__ + "static/silverGold-3b74039b5fc5e9e3f29b367fea58dbc8.svg";